export function money(value: string | number | undefined | null) {
  const amount = Number(value || 0);
  return new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(amount) + " FCFA";
}

export function dateFr(value: string | undefined | null) {
  if (!value) return "—";
  return new Date(value).toLocaleDateString("fr-FR");
}

export function todayIso() {
  const date = new Date();
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
}
